import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function requiredNonEmpty(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value.trim().length === 0) {
      return { required: 'required_non_empty' };
    }

    return null;
  };
}

export function checkPassword(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const patternAuth = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%.^&*]).{8,}$/;
    const pwd = control.value;
    if (pwd && !pwd.match(patternAuth)) {
      return { BadPassword: true };
    }
    return null;
  };
}

export function customExactLength(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    return control.value.length === 11 ? null : { billingVatCodeLength: true };
  };
}

export function checkTimeFormat(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const stringToCheck = (control.value as string).split(':');
      if (+stringToCheck[0] > 24 || +stringToCheck[1] > 59) {
        return { badTimeFormat: true };
      }
    }
    return null;
  };
}

export function checkValidSmsAdvScheduleDate(): (AbstractControl) => ValidationErrors | null {
  function checkValidTime(hour, minute) {
    if (hour > 24 || minute[1] > 59) {
      return false;
    }
    const validTime = hour + minute / 60;
    if (validTime <= 8.5 || validTime >= 22.5 || Number.isNaN(validTime)) {
      return false;
    }
    return true;
  }

  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      const dateSelected = moment(control.value);
      const today = moment();
      if (dateSelected.day() === 0 || dateSelected.day() === 6) {
        return { smsAdvScheduledDate: true };
      }
      const diffDays = moment.duration(dateSelected.diff(today)).asDays();
      // schedule days must be more than 48 hours
      if (diffDays <= 2) {
        return { smsAdvScheduledDate: true };
      }
      if (!checkValidTime(dateSelected.hour(), dateSelected.minute())) {
        return { smsAdvScheduledDate: true };
      }
    }
    return null;
  };
}

export function checkIfEmailAreEquals(emailToCompareWith): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value) {
      if (control.value !== emailToCompareWith) {
        return { emailsMustBeEqual: true };
      }
    }
    return null;
  };
}

export function checkValidSender(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    const patternAuth = /^(?=.{1,11}$)[a-zA-Z0-9._ @+&#!$'`^~-]+$|^(?=.{1,16}$)[0-9+]+$/;
    if (control.value) {
      if (!control.value.match(patternAuth)) {
        return { badSender: true };
      }
    }
    return null;
  };
}

export function checkDefaultSender(): (AbstractControl) => ValidationErrors | null {
  return (control: AbstractControl): ValidationErrors | null => {
    // same as precedent with &
    const patternAuth = /^(?!\s*$)(?=.{1,11}$)[a-zA-Z0-9\s._@+#!$'`^~&-]+$|^(?!\s*$)(?=.{1,16}$)[0-9\s+]+$/;
    if (!control.value.match(patternAuth)) {
      return { badSender: true };
    }
    return null;
  };
}

export class CustomValidators {
  // validating array of emails
  static validateEmail() {
    return (control: AbstractControl) => {
      // const pattern = new RegExp('^([a-z0-9\\+_\\-]+)(\\.[a-z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$', 'i');
      const pattern = new RegExp('^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$', 'i');
      let validEmail = true;
      if (control.value !== null) {
        const emails = control.value
          .replace(/\s/g, '')
          .split(',')
          .filter((mail: any) => mail.trim());
        for (const email of emails) {
          if (email && !pattern.test(email)) {
            validEmail = false;
          }
        }
      }
      return validEmail ? null : { email: true };
    };
  }
}

export function senderValidator(maxLength = 15): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value: string = control.value;
    if (value) {
      if (value.length < 4) {
        return { minlength: true };
      }
      if (value.length > maxLength) {
        return { maxlength: true };
      }
      const specialCharactersPattern = /^[a-zA-Z0-9\s*$?!"#%&\.\-\+_]+$/;
      if (!specialCharactersPattern.test(value)) {
        return { pattern: true };
      }
    }

    return null;
  };
}

// Array Validators
export class FileArrayValidator {
  // need to check if one formcontrol name file in formarray is not empty
  static requiredFileArray(control: AbstractControl): ValidationErrors | null {
    const files = control.value;
    if (files) {
      const filesArray = files.filter(file => file.file);
      if (filesArray.length === 0) {
        return { required: true };
      }
    }
    return null;
  }
}

export function requiredFileArray(minlength = 1): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const files = control.value;
    if (files) {
      const filesArray = files.filter(file => file.file);
      if (filesArray.length < minlength) {
        return { required: true };
      }
    }
    return null;
  };
}
